import { generatePairings } from '../../lib/claude'
import { resolvePairingPayload } from '../../lib/pairingPayload'
import { useEffect, useState } from 'react'
import { useWishList } from '../../hooks/useWishList'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../App'
import { wishListPartners, WISH_LIST_SOURCE } from '../../lib/wishList'
import PairingSuggestionList from '../layering/PairingSuggestionList'

export default function WishListSuggestions({ fragrance, collection }) {
  const wishes = useWishList()
  const { user } = useAuth()
  const [candidates, setCandidates] = useState([])
  const [error, setError] = useState('')
  const [generating, setGenerating] = useState(false)
  const [busy, setBusy] = useState(false)
  useEffect(() => {
    let live = true
    setCandidates([])
    if (!wishes.enabled || !fragrance?.catalog_id || !user?.id || !wishes.rows.length) return
    supabase.rpc('get_layering_recommendations', { target_catalog_id: fragrance.catalog_id, user_id: user.id, limit_count: 1000 })
      .then(({ data, error }) => { if (live) { setCandidates(error ? [] : data || []); setError(error ? 'Wish-list suggestions are temporarily unavailable.' : '') } })
      .catch(() => { if (live) setError('Wish-list suggestions are temporarily unavailable.') })
    return () => { live = false }
  }, [fragrance?.catalog_id, user?.id, wishes.enabled, wishes.rows])
  if (!wishes.available) return null
  const partners = wishListPartners(candidates, wishes.rows, collection, wishes.enabled, fragrance?.catalog_id).slice(0, 5)
  const toggle = async event => {
    setBusy(true); setError('')
    try { await wishes.setEnabled(event.target.checked) } catch (err) { setError(err.message) } finally { setBusy(false) }
  }
  const generate = async () => {
    setGenerating(true); setError('')
    try {
      const ownedIds = new Set(collection.map(row => row.catalog_id))
      const secondSet = wishes.rows.filter(row => !ownedIds.has(row.catalog_id))
        .map(row => ({ ...row.catalog, catalog_id: row.catalog_id, source_label: WISH_LIST_SOURCE }))
      const result = await generatePairings(fragrance, collection, secondSet)
      const resolved = await resolvePairingPayload(supabase, result.pairings)
      setCandidates(resolved)
    } catch (err) { setError(err.message || 'Could not generate wish-list previews.') }
    finally { setGenerating(false) }
  }
  return <div className="mt-4 border-t border-white/10 pt-4" data-wish-list-suggestions>
    <label className="flex min-h-11 items-center gap-3 text-sm text-cream"><input type="checkbox" checked={wishes.enabled} disabled={busy} onChange={toggle} />Also suggest partners from my wish list</label>
    <p className="mb-3 text-xs text-cream/50">One setting for every bottle — it does not add this bottle to your wish list. To do that, use Remove, then Move to my wish list.</p>
    {error && <p role="alert" className="text-xs text-red-400">{error}</p>}
    {wishes.enabled && wishes.rows.length > 0 && <button type="button" className="mb-3 min-h-11 rounded-lg border border-gold/30 px-3 text-xs text-gold" disabled={generating} onClick={generate}>{generating ? 'Generating…' : 'Generate wish-list ideas'}</button>}
    <PairingSuggestionList pairings={partners} anchor={fragrance} collection={collection} />
  </div>
}
